// /src/components/SalesDashboard/SalesDashboard.jsx
import React, { useState, useEffect } from "react";
import imgs from "../../Utils/assets/img/faces/5.jpg";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import useSessionStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { GetRequest } from "../../Utils/hooks/ApiHandler";
import { formatToINR } from "../../Utils/helpers/commonhelper";
import img1 from "../../Utils/assets/img/faces/5.jpg";
import img2 from "../../Utils/assets/img/faces/6.jpg";
import img3 from "../../Utils/assets/img/faces/7.jpg";
import { Image } from "react-bootstrap";
import leads_no_data_found_removebg from "../../Utils/assets/img/leads_no_data_found_removebg.png";

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

/**
 * NOTE:
 * - This component preserves all original class names from your HTML.
 * - The original <style> block from the HTML is injected below (so UI matches).
 * - Ensure your project's font-awesome / tabler / boxicons CSS are loaded globally
 *   (you mentioned having them installed earlier). If not, include them in index.html or via npm.
 */

export default function SalesDashboard() {
  useEffect(() => {
    // initialize any Bootstrap tooltips if needed
    try {
      /* global bootstrap */
      const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        // eslint-disable-next-line no-undef
        if (window.bootstrap && window.bootstrap.Tooltip) {
          new window.bootstrap.Tooltip(tooltipTriggerEl);
        }
      });
    } catch (e) {
      // ignore if bootstrap tooltip not available
    }

    // placeholder: if your project loads apexcharts and hrm-dashboard.js, they will run as before.
    // We do not import or run external scripts here.
  }, []);
  const [profitData, setProfitData] = useState([]);

  const [customer, setCustomer] = useSessionStorageState("customer");
  const headers = {
    Authorization: customer?.token?.authorization,
    Authentication: customer?.token?.authentication,
  };
  const customerId = customer?.customer_details?.customer_id;
  const userId = customer?.customer_details?.id;
  const rf = customer?.token?.authentication;
  const navigate = useNavigate();
  const extras = { customer, setCustomer, rf, navigate };
  const [revenue, setRevenue] = useState([]);
  const imgArr = [img1, img2, img3];
  // getting random images function
  const getRandomImage = () => {
    const imgIndex = Math.floor(Math.random() * imgArr.length);
    return imgArr[imgIndex];
  };
  // state for deals summary
  const [dealsSumm, setDealsSumm] = useState({});

  // state for bill summary
  const [billSumm, setBillSumm] = useState();

  // upcoming event state
  const [upcomingEvent, setUpcomingEventData] = useState(null);

  const [barCount, setBarCount] = useState(0);

  //revenue client data
  const [revenueClientData, setRevenueClientData] = useState(null);

  // total revenue
  const [totalRevenue, setTotalrevenue] = useState(0);
  const [duration, setDuration] = useState("year");
  const [salesDashboardCardData, setSalesDashboardCardData] = useState([]);
  const getDate = (dated) => {
    const date = new Date(dated);
    let formattedDate;
    if (date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      formattedDate = `${day}/${month}/${year}`;
    }
    return formattedDate;
  };
  const fetchRevenueSummary = async () => {
    try {
      const res = await GetRequest(
        `dashboard/revenueAnalytics_year/${customerId}/${userId}`,
        { headers },
        { extras }
      );

      if (res.status === false) return;

      const { totalProjection, totalSales, totalRevenue } = res.data.reduce(
        (acc, item) => {
          acc.totalProjection += Number(item.Projection) || 0;
          acc.totalSales += Number(item.sales) || 0;
          acc.totalRevenue += Number(item.revenue) || 0;
          return acc;
        },
        { totalProjection: 0, totalSales: 0, totalRevenue: 0 }
      );


      const grandTotal = totalProjection + totalSales + totalRevenue;

      setTotalrevenue(grandTotal);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRevenue = async () => {
    try {
      const res = await GetRequest(
        `dashboard/topRevenueClient/${customerId}/${userId}`,
        { headers },
        { extras }
      );
      if (res.status === false) {
        return;
      }
      if (res.data) {
        const data = res.data?.map((c) => ({
          fullname: c.contact_name,
          email: c.email,
          budget: c.totalBudget,
        }));
        setRevenueClientData(data);
      }
    } catch (error) {
      return;
    }
  };

  //  function for fetchimg the performance of the year graph

  const performanceByCategory = async () => {
    let endpoint;
    try {
      if (duration === "year") {
        endpoint = `dashboard/categoryPerformance_year`;
      }
      if (duration === "week") {
        endpoint = `dashboard/categoryPerformance_week`;
      }
      if (duration === "sixmonth") {
        endpoint = `dashboard/categoryPerformance_halfYear`;
      }
      if (duration === "month") {
        endpoint = `dashboard/categoryPerformance_month`;
      }

      const res = await GetRequest(
        `${endpoint}/${customerId}/${userId}`,
        { headers },
        { extras }
      );
      if (res.status === false) {
        return;
      }
      setBarCount(res.data.length);

      const data = res.data?.map((c) => ({
        ...c,
        month: c.month?.slice(0, 3),
      }));
      setProfitData(data);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    performanceByCategory();
  }, [duration]);

  useEffect(() => {
    fetchRevenue();
    fetchRevenueSummary();
  }, []);

  // deals summary
  useEffect(() => {
    (async () => {
      try {
        const res = await GetRequest(
          `dashboard/dealsSummary/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        );
        if (res.status === false) {
          return;
        }
        setDealsSumm(res.data && res.data);
      } catch (error) {
        return;
      }
    })();
  }, []);
  // bills summary
  useEffect(() => {
    (async () => {
      try {
        const res = await GetRequest(
          `dashboard/billSummary/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        );
        if (res.status === false) {
          return;
        }
        if (res.data) {
          setBillSumm(
            res.data?.map((c) => {
              const parsedItems = JSON.parse(c.items);
              const totalBudget = formatToINR(parsedItems[0]["grand-total"]);
              return {
                invoice_no: c.invoice_number,
                fullname: c.contact_name,
                email: c.email,
                due_date: getDate(c.due_date),
                amount: totalBudget,
              };
            })
          );
        }
      } catch (error) {
        return;
      }
    })();
  }, []);

  const formatTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12; // Convert 0 to 12, 13 to 1, etc.
    return `${formattedHour}:${minutes}${ampm}`;
  };
  // upcoming events
  useEffect(() => {
    (async () => {
      try {
        const res = await GetRequest(
          `dashboard/upcomingEvent/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        );
        if (res.status === false) {
          return;
        }
        if (res.data) {
          const data = Object.entries(res.data)?.map(([key, value]) => ({
            feedback: value.feedback,
            date: value.created_at?.split(" ")[0],
            time: value.created_at?.split(" ")[0],
            next_followup: value.next_followup?.split(" ")[0],
            created_at: value.created_at?.split(" ")[0],
            status: value.status,
          }));

          setUpcomingEventData(data);
        }
      } catch (error) {
        return;
      }
    })();
  }, []);

  const fetchSalesDashBoardCard = async () => {
    try {
      const res = await GetRequest(
        `/dashboard/salesDashboardCard/${customerId}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );
      if (res.status === "fail" || res.status !== "success") {
        return setSalesDashboardCardData([]);
      }
      if (res.status === "success") {
        setSalesDashboardCardData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchSalesDashBoardCard();
  }, []);

  return (
    <div className="mt-3">
      {/* Inject original CSS block to keep exact styling (you can later move this into SalesDashboard.css) */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
body{
    background: #f3f3f3;
}

.text-truncate {
    font-size: 13px !important;
}

.card.custom-card{
    border: 1px solid #cfeaf3;
    box-shadow: 0px 0px 15px #e9e9e9;
}

.nav-underline .nav-link.active,
.nav-underline .show>.nav-link{
    border: none;
    border-bottom: 2px solid;
    border-radius: 0;
    height: 100%;
    cursor: pointer;
    padding-bottom: 0px;
    display: flex;
    align-items: center;
}

.nav-underline .nav-link{
    height: 100%;
    padding-bottom: 0px;
    display: flex;
    border: none;
    font-size: .87rem;
    align-items: center;
    color: #767676;
}

.card-header {
    margin-bottom: 15px;
    padding: 0.9rem 1.5rem;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
}

.card-header h3 {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-header span {
    font-size: 14px;
    color: #777;
}

.recharts-bar-rectangle:hover {
    stroke: none !important;
}

.recharts-active-bar {
    stroke: none !important;
    stroke-width: 0 !important;
}

.recharts-bar-rectangle {
    stroke: none !important;
}

.addEnquiryHead:before {
    content: "";
    position: absolute;
    height: 1.1rem;
    width: 0.2rem;
    inset-block-start: 1.3rem;
    inset-inline-start: 1.8rem;
    background: linear-gradient(
        to bottom,
        var(--primary05) 50%,
        rgba(var(--secondary-rgb), 0.5) 50%
    );
    border-radius: 0.5rem;
}

.card-title{
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    padding-top: 0.2rem;
}
`,
        }}
      />

      {/* Begin converted HTML (JSX) */}

      {/* main-content */}
      <div className="main-content">
        <div className="">
          {/* Page Header */}
          {/* <div className="d-md-flex d-block align-items-center justify-content-between my-4 mt-3 page-header-breadcrumb">
            <div>
              <p className="fw-semibold fs-24 mb-0">Sales Dashboard</p>
              <span className="fs-semibold text-muted">Track your sales activity, leads and deals here.</span>
            </div>
          </div> */}

          {/* Start::row-1 */}
          <div className="row">
            <div className="col-xxl-5 col-xl-12">
              <div className="row">
                <div className="ps-0 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                  <div className="card custom-card hrm-main-card primary">
                    <div className="card-body p-0 w-100">
                      <div className="d-flex align-items-top">
                        <div className="me-0">
                          <span className="avatar bg-primary">
                            <i className="fa fa-users fs-18" />
                          </span>
                        </div>
                        <div className="flex-fill mx-2">
                          <span className="fw-semibold text-muted d-block mb-2 fs-13 text-nowrap">
                            Total Executives
                          </span>
                          <h5 className="fw-semibold mb-2">
                            {salesDashboardCardData?.total_customer}
                          </h5>
                          <p className="mb-0 d-flex justify-content-between">
                            <span className="badge bg-primary-transparent">
                              This Month
                            </span>
                            <div>
                              <span className="fs-12 fw-semibold text-success">
                                +1.03%
                              </span>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 ps-0">
                  <div className="card custom-card hrm-main-card secondary">
                    <div className="card-body p-0 w-100">
                      <div className="d-flex align-items-top">
                        <div className="me-0">
                          <span className="avatar bg-secondary">
                            <i className="fa fa-user-xmark fs-18" />
                          </span>
                        </div>
                        <div className="flex-fill mx-2">
                          <span className="fw-semibold text-muted d-block mb-2 fs-13 text-nowrap">
                            Employees On Leave
                          </span>
                          <h5 className="fw-semibold mb-2">528</h5>
                          <p className="mb-0 d-flex justify-content-between">
                            <span className="badge bg-secondary-transparent">
                              This Month
                            </span>
                            <div>
                              <span className="fs-12 fw-semibold text-success">
                                +0.36%
                              </span>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="ps-0 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 ps-0">
                  <div className="card custom-card  hrm-main-card warning">
                    <div className="card-body p-0 w-100">
                      <div className="d-flex align-items-top">
                        <div className="me-0">
                          <span className="avatar bg-warning">
                            <i className="fa fa-user fs-18" />
                          </span>
                        </div>
                        <div className="flex-fill mx-2">
                          <span className="fw-semibold text-muted d-block mb-2 fs-13 text-nowrap">
                            Total Customers
                          </span>
                          <h5 className="fw-semibold mb-2">
                            {salesDashboardCardData?.total_user}
                          </h5>
                          <p className="mb-0 d-flex justify-content-between">
                            <span className="badge bg-warning-transparent">
                              This Month
                            </span>
                            <div>
                              <span className="fs-12 fw-semibold text-danger">
                                -1.28%
                              </span>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="ps-0 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 ps-0">
                  <div className="card custom-card  hrm-main-card danger">
                    <div className="card-body p-0 w-100">
                      <div className="d-flex align-items-top">
                        <div className="me-0">
                          <span className="avatar bg-danger">
                            <i className="fa fa-user-plus fs-18" />
                          </span>
                        </div>
                        <div className="flex-fill mx-2">
                          <span className="fw-semibold text-muted d-block mb-2 fs-13 text-nowrap">
                            New Leads
                          </span>
                          <h5 className="fw-semibold mb-2">
                            {salesDashboardCardData?.deals}
                          </h5>
                          <p className="mb-0 d-flex justify-content-between">
                            <span className="badge bg-warning-transparent">
                              This Month
                            </span>
                            <div>
                              <span className="fs-12 fw-semibold text-success">
                                +4.25%
                              </span>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-12 ps-0">
                  <div className="  p-0" style={{ border: "1px solid #d0eaf3", backgroundColor: "white", height: "9.5rem", borderRadius: '10px', marginBottom: "13px" }}>
                    <div className="card-header" style={{ width: "100%" }}>
                      <div className="card-title addEnquiryHead">
                        Revenue Summary
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-flex" style={{ padding: "0px 8px" }}>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12" >
                          <div className="d-flex align-items-top">
                            <div className="me-3">
                              <span className="avatar avatar-rounded bg-light text-primary">
                                <i className="ti ti-files fs-18" />
                              </span>
                            </div>
                            <div>
                              <span className="d-block mb-1 text-muted fs-13" style={{ textWrap: "nowrap" }}>
                                Budget Forecast
                              </span>
                              <h6 className="fw-semibold mb-0">2,981</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                          <div className="d-flex align-items-top">
                            <div className="me-3">
                              <span className="avatar avatar-rounded bg-light text-secondary">
                                <i className="ti ti-file-check fs-18" />
                              </span>
                            </div>
                            <div>
                              <span className="d-block mb-1 text-muted fs-13">
                                Sales
                              </span>
                              <h6 className="fw-semibold mb-0">2,981</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                          <div className="d-flex align-items-top">
                            <div className="me-3">
                              <span className="avatar avatar-rounded bg-light text-warning">
                                <i className="ti ti-file-dislike fs-18" />
                              </span>
                            </div>
                            <div>
                              <span className="d-block mb-1 text-muted fs-13">
                                Revenue
                              </span>
                              <h6 className="fw-semibold mb-0">
                                {formatToINR(totalRevenue)}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-7 ps-0 col-xl-12">
              <div className="card custom-card w-100">
                <div
                  className="card-header justify-content-between align-items-center d-sm-flex d-block"
                  style={{ width: "100%" }}
                >
                  <div className="card-title addEnquiryHead mb-sm-0 mb-2">
                    Performance By Category
                  </div>
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      onClick={() => {
                        setDuration("week");
                      }}
                      type="button"
                      className={`btn btn-primary-light btn-sm btn-wave ${duration === "week" ? "active" : ""
                        }`}
                    >
                      1W
                    </button>
                    <button
                      onClick={() => {
                        setDuration("month");
                      }}
                      type="button"
                      className={`btn btn-primary-light btn-sm btn-wave ${duration === "month" ? "active" : ""
                        }`}
                    >
                      1M
                    </button>
                    <button
                      onClick={() => {
                        setDuration("sixmonth");
                      }}
                      type="button"
                      className={`btn btn-primary-light btn-sm btn-wave ${duration === "sixmonth" ? "active" : ""
                        }`}
                    >
                      6M
                    </button>
                    <button
                      onClick={() => {
                        setDuration("year");
                      }}
                      type="button"
                      className={`btn btn-primary-light btn-sm btn-wave ${duration === "year" ? "active" : ""
                        }`}
                    >
                      1Y
                    </button>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-start"
                  style={{ width: "100%", overflowX: "auto" }}
                >
                  <BarChart
                    className=""
                    width={900}
                    height={300}
                    data={profitData}
                    barSize={barCount}
                  >
                    <XAxis dataKey="month" />
                    <YAxis dataKey="number" />
                    <Tooltip />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Bar
                      type="monotone"
                      stackId="a"
                      fill="#865adf"
                      dataKey="deals"
                    />
                    <Bar
                      type="monotone"
                      stackId="a"
                      fill="#845adf80"
                      dataKey="sales"
                      radius={[0, 0, 0, 0]}
                    />
                    <Bar
                      type="monotone"
                      stackId="a"
                      fill="#845adf30"
                      dataKey="leads"
                    />
                  </BarChart>
                </div>
              </div>
            </div>
          </div>
          {/* End::row-1 */}

          {/* Start::row-2 */}
          <div className="row">
            {/* deals summary */}
            <div className="ps-0 col-xxl-3 col-xl-6 col-lg-6 col-md-12">
              <div className="  p-0" style={{ border: "1px solid #d0eaf3", backgroundColor: "white", borderRadius: '10px', marginBottom: "13px" }}>
                <div className="card-header" style={{ width: "100%" }}>
                  <div className="card-title addEnquiryHead">
                    Deals Summary
                  </div>
                </div>
                <div className="p-4 my-2 w-100">
                  <div className="row row-cols-12 ">
                    <div className="col p-0">
                      <div className="text-center">
                        <span className="text-muted fs-12 mb-1 hrm-jobs-legend published d-inline-block ms-2">
                          Won
                        </span>
                        <div>
                          <span className="fs-16 fw-semibold">
                            {dealsSumm.won}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col p-0">
                      <div className="text-center">
                        <span className="text-muted fs-12 mb-1 hrm-jobs-legend private d-inline-block ms-2">
                          Unqualified
                        </span>
                        <div>
                          <span className="fs-16 fw-semibold">
                            {dealsSumm.unqualified}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col p-0">
                      <div className="text-center">
                        <span className="text-muted fs-12 mb-1 hrm-jobs-legend closed d-inline-block ms-2">
                          Lost
                        </span>
                        <div>
                          <span className="fs-16 fw-semibold">
                            {dealsSumm.lost}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col p-0">
                      <div className="text-center">
                        <span className="text-muted fs-12 mb-1 hrm-jobs-legend onhold d-inline-block ms-2 ">
                          open
                        </span>
                        <div>
                          <span className="fs-16 fw-semibold">
                            {dealsSumm.open}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-4 ps-0 col-xl-6 col-lg-6 col-md-12">
              <div className="  p-0" style={{ border: "1px solid #d0eaf3", backgroundColor: "white", maxHeight: '31.6rem', minHeight: "31.6rem", overflowY: "scroll", overflowX: "hidden", scrollBehavior: "smooth", borderRadius: '10px', marginBottom: "13px" }}>
                <div className="card-header" style={{ width: "100%" }}>
                  <div className="card-title addEnquiryHead">
                    Upcoming Events
                  </div>
                </div>
                <div className="card-body" style={{ paddingRight: "10px", paddingLeft: "20px" }}>
                  <ul className="list-unstyled timeline-widget mb-0 my-3">
                    {upcomingEvent !== null &&
                      upcomingEvent?.map((item, index) => {
                        const day = item.date.split("-")[2];
                        return (
                          <li className="timeline-widget-list" key={index}>
                            <div className="d-flex  align-items-top">
                              <div className="me-5 text-center">
                                <span className="d-block fs-20 fw-semibold text-primary">
                                  {day}
                                </span>
                                <span className="d-block fs-12 text-muted">
                                  {new Date(item?.date).toLocaleDateString(
                                    "en-US",
                                    { weekday: "short" }
                                  )}
                                </span>
                              </div>
                              <div
                                className="d-flex  align-items-top justify-content-end "
                                style={{ gap: "1rem" }}
                              >
                                <div>
                                  <p
                                    className="mb-1 timeline-widget-content"
                                    style={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      width: "280px",
                                    }}
                                  >
                                    {item.feedback}
                                  </p>
                                  <p className="mb-0 fs-12 lh-1 text-muted">
                                    {item.time}
                                    <span className="badge bg-primary-transparent ms-2">
                                      Feedback
                                    </span>
                                  </p>
                                </div>
                                <div className="dropdown">
                                  <a
                                    aria-label="anchor"
                                    href="javascript:void(0);"
                                    className="p-2 fs-16 text-muted"
                                    data-bs-toggle="dropdown"
                                  >
                                    <i className="fa-solid fa-ellipsis-vertical" />
                                  </a>
                                  <ul className="dropdown-menu">
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Action
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Another action
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Something else here
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xxl-5 ps-0 col-xl-12">
              <div className="  p-0" style={{ border: "1px solid #d0eaf3", backgroundColor: "white", borderRadius: '10px', marginBottom: "13px" }}>
                <div className="card-header" style={{ width: "100%" }}>
                  <div className="card-title addEnquiryHead">
                    Clients
                  </div>
                </div>
                <div
                  className="card-body px-3 w-100"
                  style={{
                    height: "calc(30.5rem - 60px)", // card body fixed height
                    paddingRight: "0",
                  }}
                >
                  <div
                    className="table-responsive"
                    style={{
                      height: "100%", // scrolling area height
                      overflowY: "auto", // enable scroll
                      scrollbarWidth: "thin",
                      scrollbarColor: "transparent transparent",
                      transition: "scrollbar-color 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.scrollbarColor = "#888 #f1f1f1";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.scrollbarColor =
                        "transparent transparent";
                    }}
                  >
                    <table className="table text-nowrap">
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr>
                          <th scope="col">Client</th>
                          <th scope="col">Mail</th>
                          <th scope="col">Budget</th>
                        </tr>
                      </thead>
                      {revenueClientData !== null &&
                        revenueClientData?.length !== 0 ? (
                        <tbody>
                          {revenueClientData?.map((client, index) => (
                            <tr key={index}>
                              <th scope="row">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <img
                                      src={client.avatar || imgs}
                                      style={{
                                        width: "31px",
                                        borderRadius: "50%",
                                      }}
                                      alt={client.fullname}
                                    />
                                  </div>
                                  <div className="flex-grow-1 min-width-0">
                                    <span
                                      className="d-block fw-semibold text-truncate client-name"
                                      title={client.fullname}
                                    >
                                      {client.fullname}
                                    </span>
                                  </div>
                                </div>
                              </th>

                              <td className="align-middle">
                                <span
                                  className="text-truncate d-inline-block"
                                  style={{ maxWidth: "200px" }}
                                  title={client.email}
                                >
                                  {client.email}
                                </span>
                              </td>

                              <td className="align-middle">
                                {formatToINR(client.budget)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="3" className="text-center p-4">
                              <Image
                                src={leads_no_data_found_removebg}
                                className="img-fluid d-block mx-auto"
                                style={{ maxWidth: "300px" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* End::row-2 */}

          {/* Start::row-3 */}
          <div className="row">
            <div className="col-xl-12 ps-0">
              <div className="p-0" style={{ border: "1px solid #d0eaf3", backgroundColor: "white", minHeight: "30rem", borderRadius: '10px', marginBottom: "13px" }}>
                <div className="card-header" style={{ width: "100%" }}>
                  <div className="card-title addEnquiryHead">
                    Bills Summary
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    <div className=" position-relative mt-1 mt-md-0">
                      <input
                        type="search"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        // onChange={(e) => setUserSearchInput(e.target.value)}
                        style={{
                          fontSize: "12px",
                          paddingLeft: "36px",
                          height: "35px",
                        }}
                      />
                      <i
                        class="fa-solid fa-magnifying-glass"
                        style={{
                          position: "absolute",
                          marginTop: "-26px",
                          zIndex: 1,
                          marginLeft: "13px",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>

                <div className="card-body w-100">
                  <div className="table-responsive">
                    {/* <table className="table table-hover text-nowrap table-bordered"> */}
                    <table className="crm-table crm-text-nowrap crm-table-hover crm-border crm-table-bordered">
                      <thead>
                        <tr style={{ backgroundColor: "#eaf7ff" }}>
                          <th scope="col">S.No</th>
                          <th scope="col">Invoice ID</th>
                          <th scope="col">Client</th>
                          <th scope="col">Due Date</th>
                          <th scope="col">Status</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billSumm !== null && billSumm?.length !== 0 ? (
                          <React.Fragment>
                            {billSumm?.map((bill, index) => (
                              <tr key={bill.invoice_no}>
                                <td>{index + 1}</td>
                                <td>{bill.invoice_no}</td>
                                <td>
                                  <div className="d-flex align-items-center lh-1">
                                    <div className="me-2">
                                      <span className="avatar avatar-md avatar-rounded">
                                        {/* You can add dynamic image source if available in your data */}
                                        <img
                                          src={getRandomImage()}
                                          alt={bill.fullname}
                                        />
                                      </span>
                                    </div>
                                    <div>
                                      <span className="d-block fw-semibold mb-1">
                                        {bill.fullname}
                                      </span>
                                      <span className="text-muted fs-12">
                                        {bill.email}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{bill.due_date}</td>
                                <td>
                                  <span className="badge bg-success">Paid</span>
                                  {/* If you have status in your data, use this instead: */}
                                </td>
                                <td>{bill.amount}</td>
                                <td>
                                  <div className="btn-list">
                                    <a
                                      aria-label="anchor"
                                      href="javascript:void(0);"
                                      className="btn btn-sm btn-icon btn-info-light"
                                    >
                                      <i className="fa-solid fa-pencil" />
                                    </a>
                                    <a
                                      aria-label="anchor"
                                      href="javascript:void(0);"
                                      className="btn btn-icon btn-sm btn-danger-light"
                                    >
                                      <i className="fa-solid fa-trash-can" />
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ) : (
                          <div
                            class="d-flex justify-content-center align-items-center"
                            style={{ position: "absolute", left: " 42%" }}
                          >
                            <img
                              src={leads_no_data_found_removebg}
                              alt=""
                              style={{ width: "17rem", marginTop: "0" }}
                            />
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .crm-table {
            width: 100%;
            border-collapse: collapse;
          }
          .crm-table th,
          .crm-table td {
            padding: 0.75rem;
            border: 1px solid #e5e7eb;
          }
          .crm-table thead th {
            background: #f9fafb;
            font-weight: 600;
            font-size : 14px;
            text-align: center;
          }
          .crm-table-hover tbody tr:hover {
            background: #f9fafb;
          }
        `}
      </style>
    </div>

  );
}